import { Box, Base, Block, Spin } from 'zf-web-components';
import styles from './index.module.less';
import type { ReactElement } from 'react';
import type { CaptchaProps } from './types';

export function Captcha({ isLoadingCaptcha, image, onChange }: CaptchaProps): ReactElement {
  return (
    <Box className={styles.captcha}>
      <Block if={!isLoadingCaptcha}>
        <Base.Image
          width={80}
          height={30}
          preview={false}
          src={image}
          onClick={onChange}
        />
      </Block>
      <Block if={isLoadingCaptcha}>
        <div className={styles.spin}>
          <Spin />
        </div>
      </Block>
    </Box>
  );
}
